import { ModificationDataloggerState } from './state/modification-datalogger.state';

export const modificationDataloggerStates = [ModificationDataloggerState];
